import React, { FC } from 'react';
import Form from '@sezenta/antd-schema-form';
import { Button, Input, InputNumber, Select } from 'antd';
import classNames from 'classnames';
import { ItemSelect } from '../items/ItemSelect';
import { useBusinessContext } from '../../context/BusinessContext';
import styled from 'styled-components';
import { DeleteOutlined } from '@ant-design/icons';

type Props = {
  name: number;
  onDelete: () => void;
};
const borderStyles = 'border border-gray-300 border-solid align-top';

const RightNumber = styled(InputNumber)`
  .ant-input-number-input {
    text-align: right !important;
    padding-right: 32px !important;
  }
`;

export const BillRow2: FC<Props> = (props) => {
  const business = useBusinessContext();
  return (
    <tr>
      <td className={borderStyles}>
        <div className="flex flex-col">
          <Form.Item
            style={{ marginBottom: 0 }}
            name={[props.name, 'itemId']}
            rules={[{ required: true, message: 'Item is required' }]}
          >
            <ItemSelect
              variant="borderless"
              showSearch={true}
              optionFilterProp={'label'}
              placeholder="Select Item"
            />
          </Form.Item>
          <Form.Item
            name={[props.name, 'description']}
            style={{ marginBottom: 0 }}
          >
            <Input.TextArea
              rows={1}
              variant="borderless"
              placeholder="Description"
            />
          </Form.Item>
        </div>
      </td>
      <td className={`${borderStyles} align-top`}>
        <Form.Item
          name={[props.name, 'account']}
          rules={[{ required: true, message: 'Account is required' }]}
        >
          <Select
            variant="borderless"
            showSearch={true}
            optionFilterProp={'label'}
            placeholder="Select Account"
            options={business.getAccountsForSelect(
              (account) => account.accountCategory === 'Expenses',
            )}
          />
        </Form.Item>
      </td>
      <td className={borderStyles}>
        <Form.Item
          name={[props.name, 'quantity']}
          rules={[{ required: true, message: 'Quantity is required' }]}
        >
          <RightNumber
            variant="borderless"
            placeholder="Quantity"
            style={{ width: '100%' }}
            precision={3}
          />
        </Form.Item>
      </td>
      <td className={borderStyles}>
        <Form.Item
          name={[props.name, 'rate']}
          rules={[{ required: true, message: 'Rate is required' }]}
        >
          <RightNumber
            variant="borderless"
            placeholder="Rate"
            style={{ width: '100%' }}
            precision={2}
          />
        </Form.Item>
      </td>
      <td className={borderStyles}>
        <Form.Item name={[props.name, 'tax']}>
          <Select variant="borderless" />
        </Form.Item>
      </td>
      <td className={borderStyles}>
        <div className="flex">
          <Form.Item name={[props.name, 'discountType']}>
            <Select
              variant="borderless"
              options={[
                { label: '%', value: 'Percentage' },
                { label: '$', value: 'Amount' },
              ]}
            />
          </Form.Item>
          <Form.Item name={[props.name, 'discount']}>
            <RightNumber
              variant="borderless"
              placeholder="Discount"
              style={{ width: '100%' }}
              precision={2}
            />
          </Form.Item>
        </div>
      </td>
      <td className={borderStyles}>1000.00</td>
      <td className={borderStyles}>
        <Button
          icon={<DeleteOutlined onClick={props.onDelete} />}
          type="link"
          danger={true}
        />
      </td>
    </tr>
  );
};
